module.exports = __webpack_public_path__ + "img/yogurt-fruit-shake.402944c4.jpg";